<template>
  <div v-if="data.assinante && data.registro"
       class="impressao--tamanho_14 impressao--frente">
    <b-container class="impressao_documento--margin">
      <b-row>
        <b-col cols="5"
               class="impressao_documento impressao_documento--qrcode">
          <div>
            <u>https://selodigital.tjsp.jus.br</u>.
          </div>
          <div style="letter-spacing: -1px;">
            Selo Digital: {{ data.selo.selo_digital || '0000000000000000000000000' }}
          </div>
          <div>
            <img :src="qrCodeImg"
                 class="qrcode"
                 alt="">
          </div>
        </b-col>
      </b-row>
      <b-row>
        <div class="impressao_documento impressao_documento--titulo font--18">
          CERTIDÃO {{ data.registro.tipo_registro === "O" ? "DE ÓBITO" : "NATIMORTO" }}
        </div>
      </b-row>
      <b-row>
        <b-col class="text-center font--12">
          <div class="font--7 bold text-center">
            NOME
          </div>
          <div class="uppercase bold impressao_documento--minus-margin-5">
            {{ data.nome || 'NÃO CONSTA' }}
          </div>
        </b-col>
      </b-row>

      <div class="impressao_documento--minus-margin-6">
        <b-row>
          <b-col>
            <fieldset class="fieldset-impressao text-center">
              <legend class="text-center">
                NÚMERO DO CPF
              </legend>
              <span class="bold">{{ data.cpf || 'NÃO CONSTA' }}</span>
            </fieldset>
          </b-col>
        </b-row>
        <b-row class="mt-1">
          <b-col class="text-center">
            <div class="font--8 bold">
              Matrícula
            </div>
            <div class="bold impressao_documento--minus-margin-5">
              {{ data.matricula | maskMatricula }}
            </div>
          </b-col>
        </b-row>

        <b-row no-gutters>
          <b-col cols="6">
            <fieldset class="fieldset-impressao">
              <legend>
                DATA DO FALECIMENTO
              </legend>
              <span class="bold">{{ data.data_obito || 'NÃO CONSTA' }}</span>
            </fieldset>
          </b-col>

          <b-col cols="6">
            <b-row no-gutters>
              <b-col cols="2">
                <fieldset class="fieldset-impressao ml-2 pl-0 text-center">
                  <legend class="text-center">
                    DIA
                  </legend>
                  <span class="bold">{{ (`${data.dia}`.length == 1 && '0' + data.dia || data.dia) || 'N/C' }}</span>
                </fieldset>
              </b-col>
              <b-col cols="2">
                <fieldset class="fieldset-impressao ml-2 pl-0 text-center">
                  <legend class="text-center">
                    MÊS
                  </legend>
                  <span class="bold">{{ (`${data.mes}`.length == 1 && '0' + data.mes || data.mes) || 'N/C' }}</span>
                </fieldset>
              </b-col>
              <b-col cols="2">
                <fieldset class="fieldset-impressao ml-2 pl-0 text-center">
                  <legend class="text-center">
                    ANO
                  </legend>
                  <span class="bold">{{ data.ano || 'N/C' }}</span>
                </fieldset>
              </b-col>
              <b-col cols="6"
                     class="pl-2">
                <b-row no-gutters>
                  <fieldset class="fieldset-impressao text-center">
                    <legend class="text-center">
                      HORÁRIO DO FALECIMENTO
                    </legend>
                    <span class="bold">{{ data.horario || 'NÃO CONSTA' }}</span>
                  </fieldset>
                </b-row>
              </b-col>
            </b-row>
          </b-col>
        </b-row>

        <b-row no-gutters>
          <b-col cols="8">
            <fieldset class="fieldset-impressao mr-2">
              <legend>
                LOCAL DE FALECIMENTO
              </legend>
              <span class="bold">{{ data.local_obito || 'NÃO CONSTA' }}</span>
            </fieldset>
          </b-col>
         
          <b-col cols="3">
            <fieldset class="fieldset-impressao">
              <legend>
                MUNICÍPIO DE FALECIMENTO 
              </legend>
              <span class="bold">{{ data.municipio_obito || 'NÃO CONSTA' }}</span>
            </fieldset>
          </b-col>
         
          <b-col cols="1">
            <fieldset class="fieldset-impressao ml-2">
              <legend>
                UF
              </legend>
              <span class="bold">{{ data.uf_obito || 'N/C' }}</span>
            </fieldset>
          </b-col>
        </b-row>

        <b-row no-gutters>
          <b-col cols="3">
            <fieldset class="fieldset-impressao mrpx-5">
              <legend>
                SEXO
              </legend>
              <span class="bold">{{ data.sexo || 'NÃO CONSTA' }}</span>
            </fieldset>
          </b-col>
          <b-col cols="3">
            <fieldset class="fieldset-impressao mlpx-5">
              <legend>
                ESTADO CIVIL
              </legend>
              <span class="bold">{{ data.estado_civil || 'NÃO CONSTA' }}</span>
            </fieldset>
          </b-col>
          <b-col cols="6">
            <fieldset class="fieldset-impressao mlpx-5">
              <legend>
                NOME DO ÚLTIMO CÔNJUGE OU CONVIVENTE
              </legend>
              <span class="bold">{{ data.ultimo_convivente || 'NÃO CONSTA' }}</span>
            </fieldset>
          </b-col>
        </b-row>

        <b-row no-gutters>
          <b-col cols="2">
            <fieldset class="fieldset-impressao mrpx-5">
              <legend>
                IDADE
              </legend>
              <span class="bold">{{ data.idade || 'NÃO CONSTA' }}</span>
            </fieldset>
          </b-col>
          <b-col cols="1">
            <fieldset class="fieldset-impressao mlpx-5">
              <legend>
                DIA
              </legend>
              <span class="bold">{{ data.idade_dia || 'N/C' }}</span>
            </fieldset>
          </b-col>
          <b-col cols="1">
            <fieldset class="fieldset-impressao mlpx-5">
              <legend>
                MÊS
              </legend>
              <span class="bold">{{ data.idade_mes || 'N/C' }}</span>
            </fieldset>
          </b-col>
          <b-col cols="1">
            <fieldset class="fieldset-impressao mlpx-5">
              <legend>
                ANO
              </legend>
              <span class="bold">{{ data.idade_ano || 'N/C' }}</span>
            </fieldset>
          </b-col>
          <b-col cols="6">
            <fieldset class="fieldset-impressao mlpx-5">
              <legend>
                MUNICÍPIO DA NATURALIDADE
              </legend>
              <span class="bold">{{ data.municipio_de_nascimento || 'NÃO CONSTA' }}</span>
            </fieldset>
          </b-col>
          <b-col cols="1">
            <fieldset class="fieldset-impressao ml-2 municipio_de_naturalidade_uf">
              <legend>
                UF
              </legend>
              <span class="bold">{{ data.municipio_de_nascimento_uf || 'N/C' }}</span>
            </fieldset>
          </b-col>
        </b-row>
        
        <b-row>
          <b-col>
            <fieldset class="fieldset-impressao">
              <legend>
                NOME DO(A)S GENITOR(ES)
              </legend>
              <span class="bold"
                    v-html="data.genitores || 'NÃO CONSTA'" />
            </fieldset>
          </b-col>
        </b-row>

        <b-row no-gutters>
          <b-col>
            <fieldset class="fieldset-impressao">
              <legend>
                CAUSA DA MORTE
              </legend>
              <span class="bold">{{ data.causas_morte || 'NÃO CONSTA' }}</span>
            </fieldset>
          </b-col>
        </b-row>

        <b-row no-gutters>
          <b-col cols="8">
            <fieldset class="fieldset-impressao">
              <legend>
                NOME DO MÉDICO QUE ATESTOU O ÓBITO OU, SE FOR O CASO, DAS TESTEMUNHAS
              </legend>
              <span class="bold">{{ data.medico_nome || 'NÃO CONSTA' }}</span>
            </fieldset>
          </b-col>
          <b-col cols="4">
            <fieldset class="fieldset-impressao">
              <legend>
                NÚMERO DO DOCUMENTO
              </legend>
              <span class="bold">{{ data.medico_crm || 'NÃO CONSTA' }}</span>
            </fieldset>
          </b-col>
        </b-row>

        <b-row no-gutters>
          <b-col cols="4">
            <fieldset class="fieldset-impressao">
              <legend>
                LOCAL DE SEPULTAMENTO / CREMAÇÃO 
              </legend>
              <span class="bold">{{ data.sepultamento_cremacao || 'NÃO CONSTA' }}</span>
            </fieldset>
          </b-col>
          <b-col cols="7">
            <fieldset class="fieldset-impressao">
              <legend>
                MUNICÍPIO
              </legend>
              <span class="bold">{{ data.sepultamento_cremacao_municipio || 'NÃO CONSTA' }}</span>
            </fieldset>
          </b-col>
          <b-col cols="1">
            <fieldset class="fieldset-impressao ml-2">
              <legend>
                UF
              </legend>
              <span class="bold">{{ data.sepultamento_cremacao_uf || 'N/C' }}</span>
            </fieldset>
          </b-col>
        </b-row>

        <b-row no-gutters>
          <b-col cols="12"
                 class="d-flex justify-content-between">
            <b-col cols="9"
                   class="p-0">
              <fieldset class="fieldset-impressao">
                <legend>
                  DATA DE REGISTRO
                </legend>
                <span class="bold">{{ data.data_de_registro || 'NÃO CONSTA' }}</span>
              </fieldset>
            </b-col>
            <b-col cols="1"
                   class="p-0">
              <fieldset class="fieldset-impressao">
                <legend>
                  DIA
                </legend>
                <span class="bold">{{ data.data_de_registro_dia || 'N/C' }}</span>
              </fieldset>
            </b-col>
            <b-col cols="1"
                   class="p-0">
              <fieldset class="fieldset-impressao">
                <legend>
                  MÊS
                </legend>
                <span class="bold">{{ data.data_de_registro_mes || 'N/C' }}</span>
              </fieldset>
            </b-col>
            <b-col cols="1"
                   class="p-0">
              <fieldset class="fieldset-impressao">
                <legend>
                  ANO
                </legend>
                <span class="bold">{{ data.data_de_registro_ano || 'N/C' }}</span>
              </fieldset>
            </b-col>
          </b-col>
        </b-row>

        <b-row no-gutters>
          <b-col cols="5">
            <fieldset class="fieldset-impressao">
              <legend>
                NOME DO DECLARANTE
              </legend>
              <span class="bold">{{ data.declarante || 'NÃO CONSTA' }}</span>
            </fieldset>
          </b-col>
          <b-col cols="3">
            <fieldset class="fieldset-impressao ml-2">
              <legend>
                EXISTÊNCIA DE BENS
              </legend>
              <span class="bold">{{ data.existencia_de_bens || 'NÃO CONSTA' }}</span>
            </fieldset>
          </b-col>
          <b-col cols="4">
            <fieldset class="fieldset-impressao ml-2">
              <legend>
                EXISTÊNCIA DE FILHOS 
              </legend>
              <span class="bold">{{ data.filhosText || 'NÃO CONSTA' }}</span>
            </fieldset>
          </b-col>
        </b-row>

        <b-row no-gutters>
          <b-col>
            <fieldset class="fieldset-impressao">
              <legend>ANOTAÇÕES/AVERBAÇÕES</legend>
              <span v-if="data.averbacoes_anotacoes && data.averbacoes_anotacoes.length < 850 "
                    class="text-justify text-break"
                    v-html="data.averbacoes_anotacoes" />
              <span v-if="data.averbacoes_anotacoes && data.averbacoes_anotacoes.length > 850 "
                    class="text-justify bold"
                    v-html="'VIDE VERSO.'" />
              <span v-if="!data.averbacoes_anotacoes "
                    class="text-justify bold"
                    v-html="'NÃO CONSTA'" />
            </fieldset>
          </b-col>
        </b-row>

        <b-row no-gutters>
          <b-col>
            <fieldset class="fieldset-impressao">
              <legend>
                ANOTAÇÕES VOLUNTÁRIAS DE CADASTRO
              </legend>
              <span class="bold">{{ (data.anotacoes.length && "VIDE VERSO.") || "NÃO CONSTA" }}</span>
            </fieldset>
          </b-col>
        </b-row>

        <!-- TODO: ARRUMAR DADOS DO CARTORIO -->
        <b-row class="impressao_documento--rodape mt-3 text-center">
          <b-col cols="5"
                 class="font--8 pr-1">
            <div style="white-space: nowrap;">
              Oficial de Registro Civil das Pessoas Naturais
              <br>
              {{ data.cartorio && data.cartorio.nome || 'NÃO CONSTA' }} - {{ data.cartorio && data.cartorio.endereco ? data.cartorio.endereco.uf : 'N/C' }}
            </div>
            <div class="mt-2">
              {{ data.oficial || 'NÃO CONSTA' }} - Oficial
            </div>
            <div v-if="data.cartorio"
                 class="mt-2">
              {{ data.cartorio.endereco && data.cartorio.endereco.logradouro || 'NÃO CONSTA' }}, nº {{ data.cartorio.endereco && data.cartorio.endereco.numero || 'NÃO CONSTA' }} - {{ data.cartorio.endereco && data.cartorio.endereco.bairro || 'NÃO CONSTA' }}
              CEP: {{ data.cartorio.endereco && data.cartorio.endereco.cep || 'NÃO CONSTA' }} - Fone: {{ data.cartorio.telefone || 'NÃO CONSTA' }}
              <br>e-mail: {{ data.cartorio.email || 'NÃO CONSTA' }}
            </div>
          </b-col>
          <b-col>
            <div>
              O Conteúdo da certidão é verdadeiro. Dou fé.
            </div>
            <div v-if="data.cartorio">
              {{ data.cartorio.endereco && data.cartorio.endereco.cidade || 'NÃO CONSTA' }} - {{ data.cartorio.endereco && data.cartorio.endereco.uf || 'N/C' }}, {{ data.data_atual || 'NÃO CONSTA' }}.
            </div>
            <div>
              <hr class="hr--assinatura">
              <div class="d-inline-flex">
                {{ data.assinante.nome || 'NÃO CONSTA' }} - {{ data.assinante.cargo || 'NÃO CONSTA' }}
              </div>
            </div>
            <div class="mt-1">
              <div v-if="data.emolumentosFiltrados && !data.emolumentosFiltrados[data.emolumentosFiltrados.length - 1].valor.match('0,00')">
                Valor pago por essa certidão:<br>
                <span v-for="(emolumento, index) in data.emolumentosFiltrados"
                      :key="`emolumento_${ _uid }_${ index }`">
                  <br v-if="emolumento.destino == 'Total' || emolumento.destino == 'AVERBAÇÕES'">
                  <b v-if="emolumento.destino == 'Total'">{{ emolumento.destino }}: {{ emolumento.valor }};</b>
                  <span v-else>{{ emolumento.destino }}: {{ emolumento.valor }};</span>
                </span>
              </div>

              <div v-if="!data.emolumentosFiltrados || !!data.emolumentosFiltrados[data.emolumentosFiltrados.length - 1].valor.match('0,00')">
                <b>{{ destino.primeiraVia ? '1ª' : '2ª' }} VIA ISENTA DE EMOLUMENTOS</b>
              </div>
            </div>
          </b-col>
        </b-row>
      </div>
    </b-container>
  </div>
</template>

<script>
  /* image */
  import qrCodeImg from '@/assets/img/qrcode.png'

  export default {
    name: "FrenteImpressaoObito",
    props: ["data"],
    data () {
      return {
        newData: this.data,
        qrCodeImg,
        destino: {
          primeiraVia: false,
          segundaVia: false
        }
      }
    },
    watch: {
      data () {
        this.newData = {...this.data}

        // Atualiza destino
        this.destino = { primeiraVia: false, segundaVia: false }

        const osSelected = this.data.ordemServicoSelected


        if (!osSelected) return

        // Selecionado o item da OS com o selo selecionado
        const itemOsSelecionado = osSelected.itens.find(itemOS => {
          return itemOS.seloItemOs.find(seloItem => seloItem.selo.num_selo === this.data.selo.selo_digital)
        })

        // Verifica se o item da OS está com valor zerado
        const osComItemZerado = itemOsSelecionado && itemOsSelecionado.valor === 0

        // Valida OS e com item zerado
        if (!osSelected || !osSelected.itens.length || (osSelected.valor_total > 0 && !osComItemZerado)) return

        const primeiraVia = osSelected.itens.find(item => !item.flag_cancelado && (item.custa.codigo === 16 || item.custa.codigo === 19)) // AN e AO

        const segundaVia = osSelected.itens.find(item => !item.flag_cancelado && item.custa.codigo !== 16 && item.custa.codigo !== 19)

        if (primeiraVia) {
          this.destino = { primeiraVia: true, segundaVia: false }
        } else if (segundaVia) {
          this.destino = { primeiraVia: false, segundaVia: true }
        }
      }
    }
  }
</script>

<style scoped>
  .qrcode {
    width: 100px;
  }

  .municipio_de_naturalidade_uf {
    min-height: 1.95em;
  }
</style>